import { render, staticRenderFns } from "./LeavePageDetailsModal.vue?vue&type=template&id=02c93516&scoped=true&"
import script from "./LeavePageDetailsModal.vue?vue&type=script&lang=js&"
export * from "./LeavePageDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c93516",
  null
  
)

export default component.exports